import { apiClient } from '../../services/api';

const state = () => ({
  contas_bloqueadas: null,
});

const getters = {
  getterContasBloqueadas: state => {
    return state.contas_bloqueadas;
  },
};

const actions = {
  async getContasBloqueadas({ commit }, payload) {
    const { cod_producao } = payload;
    try {
      const { data } = await apiClient.get(
        `/listarContasBloqueadas/${cod_producao}`
      );

      commit('setContasBloqueadas', data.contas_bloqueadas);
    } catch (error) {
      return error;
    }
  },
}

const mutations = {
  setContasBloqueadas(state, payload) {
    state.contas_bloqueadas = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};